// scroll nav
$(document).scroll(function () {
    var $nav = $("#mainNav");
    if($(this).scrollTop() > $nav.height()){
        $("#mainNav").addClass("scrolled");
        $('.brand-logo').attr("src","/img/png/logo.png");
        $('.brand-logo').addClass("logo-shrink");
        $('.brand-logo2').addClass("logo-shrink");
        $('.sub-nav').addClass('slide-down');
        $('.sub-nav').slideUp( 300, function(){
            $(this).removeClass('d-block').addClass('d-none')
        });
        $('.md-menu').find('.fa').addClass('fa-bars').removeClass('fa-times');
    }
    else{
        $("#mainNav").removeClass("scrolled");
        $('.brand-logo').attr("src","/img/png/logo.png");
        $('.brand-logo').removeClass("logo-shrink");
        $('.brand-logo2').removeClass("logo-shrink");
        $('.sub-nav').removeClass('slide-down');
    }
    // var $navBrand = $('.nav-brand')
    // $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
});
$(function(){
	"use strict";
	$('.nav-toggle').on('click', function(){
        
        $('.main-navigation').toggleClass('open');
        $('.nav-toggle').toggleClass('fa-bars fa-times');
        
    });
});
$(function(){
    $('.md-menu').innerWidth(37);
    $(window).resize(function(){
        $('.md-menu').innerWidth(37);
    });
});
$('.md-menu').on('click', function(e){
    e.preventDefault();
    if ($('.sub-nav').hasClass('d-none')){
        $('.sub-nav').addClass('d-block').hide().slideDown( 300 ).removeClass('d-none');
        $(this).find('.fa-bars').addClass('fa-times').removeClass('fa-bars');
    }
    else{
        $('.sub-nav').slideUp( 300, function(){
            $(this).removeClass('d-block').addClass('d-none')
        });
        $(this).find('.fa').addClass('fa-bars').removeClass('fa-times');
    }
});
// hover highlighted link
// $('.nav-link-btn').hover(function(){
//     $(this).find('.fa-tag').toggleClass('text-danger');
//     $(this).find('.fa-sign-in-alt').toggleClass('text-primary');
// });
window.addEventListener('load', function(){
    // This is to add top to main navigation for mobile
    const mobileHeader = $('.mobile-header');
    const mainNavigation = $('.main-navigation');
    mainNavigation.css('top', mobileHeader.outerHeight(true));

    // this is to add to user sub header sticky top
    const mainHeaderHeight = parseFloat($('.main-header').outerHeight(true));
    console.log($('.main-header').outerHeight(true));
    const subHeader = $('.sub-header');
    const subHeaderHeight = parseFloat(subHeader.outerHeight(true));
    subHeader.css('top', $('.main-header').outerHeight(true));
    let padding = (mainHeaderHeight - subHeaderHeight) / 2;
    subHeader.css({'padding-top': padding + 'px', 'padding-bottom' : padding + 'px'});

    // this is for subheader 2
    const subHeader2 = $('.sub-header2');
    const subHeader2Height = parseFloat(subHeader2.outerHeight(true));
    subHeader2.css('top', mainHeaderHeight + subHeader.outerHeight(true));
    let padding2 = (mainHeaderHeight - subHeader2Height) / 2;
    subHeader2.css({'padding-top': padding2+'px', 'padding-bottom' : padding2+'px'});
});